import React, { useEffect, useState } from "react";
import { BiSolidVideoPlus, BiCloudUpload } from "react-icons/bi";
import { FaStethoscope, FaRegCalendarAlt } from "react-icons/fa";
import { MdOutlineCloudUpload } from "react-icons/md";
import digiSteth from "../../../Assets/Images/digiStethnew.png";
import digiStethCard from "../../../Assets/Images/digistethCard.png";
import digistethLungs from "../../../Assets/Images/digistethLungs.png";
import ConsultationService from "../../../Services/ConsultationService";
import { message, Select, Spin, Flex } from "antd";
import dayjs from "dayjs";

const DigitalSteth = (props) => {
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [tab, setTab] = useState("Live");
  const [stethReportList, setStethReportList] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [filteredStethList, setFilteredStethList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getStethReport = async () => {
    let payload = { patientId: props.patientDetails?.patientId, status: 1 };

    try {
      setIsLoading(true);
      let result = await ConsultationService.getStethReport(payload);
      if (result?.data) {
        setStethReportList(result.data);
        setFilteredStethList(result.data);
      } else {
        setStethReportList([]);
        setFilteredStethList([]);
      }
    } catch (error) {
      console.error("Error fetching steth report", error);
      setStethReportList([]);
      setFilteredStethList([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getStethReport();
  }, []);

  const handleDateSelect = (value) => {
    setSelectedDate(value);

    if (!value) {
      setFilteredStethList(stethReportList);
      return;
    }

    const filtered = stethReportList.filter(
      (item) => item.createdDate === value
    );

    setFilteredStethList(filtered);
  };

  const convertFileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = (error) => reject(error);
    });

  const saveUploadedFile = async () => {
    if (!selectedFile) {
      message.error("Please upload a PDF file");
      return;
    }

    try {
      const base64File = await convertFileToBase64(selectedFile);
      const payload = {
        consultationId: props.appointmentDetails?.consultationId,
        createdBy: props?.appointmentDetails?.userId,
        createdDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        document: base64File,
        documentType: "pdf",
        modifiedBy: props.appointmentDetails?.userId,
        modifiedDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        ogDocumentName: selectedFile.name,
        ogDocumentType: "DIGITAL_STETHOSCOPE",
        patientId: props.patientDetails?.patientId,
        status: 1,
        userId: props.appointmentDetails?.userId,
        appointmentId: props.appointmentDetails?.appointmentId,
      };

      let res = await ConsultationService.saveSteth(payload);

      if (res.status === 200) {
        message.success("File uploaded successfully!");
        setUploadModalOpen(false);
        setSelectedFile(null);
        getStethReport();
      }
    } catch (err) {
      console.error("Upload error:", err);
      message.error("Upload failed");
    }
  };

  // Open PDF in new tab
  const openPDF = (item) => {
    if (!item?.documentName) return;
    const finalUrl = process.env.REACT_APP_IMAGE_URL + item?.documentName;
    window.open(finalUrl, "_blank");
  };


  return (
    <div className="bg-transparent w-full h-full flex flex-col overflow-hidden p-3">
      {/* Action Row */}
      <div className="flex justify-between items-center mb-6 flex-wrap gap-4 shrink-0">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2 rounded-lg px-4 py-2 bg-[#ffe8eb] text-[#143250] font-semibold text-sm">
            <FaStethoscope className="text-[#ff4d4f] text-lg" />
            <span>Saved Graphs</span>
          </div>
          
          <Select
            className="steth-date-select h-9"
            style={{ width: 180 }}
            value={selectedDate}
            onChange={handleDateSelect}
            placeholder={
              <div className="flex items-center gap-2 text-gray-400">
                <FaRegCalendarAlt />
                <span>Select Date</span>
              </div>
            }
            allowClear
          >
            {stethReportList.map((item) => (
              <Select.Option key={item.id} value={item.createdDate}>
                {dayjs.utc(item?.createdDate).local().format("DD/MM/YYYY HH:mm")}
              </Select.Option>
            ))}
          </Select>
        </div>

        <button
          className="px-4 py-2 bg-[#0aa097] text-white rounded-lg flex items-center gap-2 text-sm font-medium hover:bg-teal-600 transition-colors shadow-sm"
          onClick={() => setUploadModalOpen(true)}
        >
          <MdOutlineCloudUpload className="text-xl" />
          Upload
        </button>
      </div>

      <div className="mt-2 flex flex-col flex-1 overflow-hidden">
        <div className="flex-1 overflow-y-auto pr-2 custom-scrollbar">

          {isLoading ? (
            <div className="flex items-center justify-center mt-10">
              <Flex align="center" gap="middle">
                <Spin size="large" tip="Loading" />
              </Flex>
            </div>
          ) : filteredStethList.length === 0 ? (
            <p className="text-gray-500 text-center py-6 bg-white rounded-lg border border-gray-100">No saved graphs found.</p>
          ) : null}

          {!isLoading && <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
            {filteredStethList.map((item, idx) => {
              const isPDF = item.documentName.endsWith(".pdf");

              return (
                <div
                  key={idx}
                  className="group bg-white rounded-xl shadow-sm border border-gray-100 p-3.5 flex items-center cursor-pointer hover:shadow-md hover:border-l-4 hover:border-l-[#0aa097] hover:bg-[#F4FDFD] transition-all duration-200"
                  onClick={() => isPDF && openPDF(item)}
                  title="click to view"
                >
                  <div className="w-[42px] h-[42px] rounded-full bg-[#E8F8F5] text-[#0aa097] flex items-center justify-center text-xl mr-3 flex-shrink-0">
                    <FaStethoscope />
                  </div>
                  
                  <div className="flex-1 min-w-0">
                    <p className="font-bold text-[#143250] text-[14px] truncate mb-0.5">Stethoscope reading</p>
                    <p className="text-xs text-gray-500 flex items-center gap-1.5 font-medium">
                      <FaRegCalendarAlt className="text-gray-400" />
                      {dayjs
                        .utc(item?.createdDate)
                        .local()
                        .format("YYYY-MM-DD HH:mm:ss")}
                    </p>
                  </div>

                  <button
                    className="ml-2 px-4 py-1.5 bg-[#E8F8F5] text-[#0aa097] group-hover:bg-[#0aa097] group-hover:text-white text-[13px] font-bold rounded-lg transition-colors"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (isPDF) openPDF(item);
                    }}
                  >
                    View
                  </button>
                </div>
              );
            })}
          </div>}
        </div>
      </div>

      {uploadModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white w-[400px] p-5 rounded shadow-lg">
            <h2 className="text-lg font-semibold mb-4">Upload PDF</h2>

            <div className="mb-4">
              <label className="w-full cursor-pointer">
                <div className="px-4 py-2 bg-brand-primaryColor text-white rounded text-center hover:bg-brand-primaryColor transition">
                  {selectedFile ? "Change File" : "Choose File"}
                </div>

                <input
                  type="file"
                  accept="application/pdf"
                  className="hidden"
                  onChange={(e) => setSelectedFile(e.target.files[0])}
                />
              </label>

              {selectedFile && (
                <p className="mt-2 text-sm text-gray-600 truncate">
                  Selected:{" "}
                  <span className="font-semibold">{selectedFile.name}</span>
                </p>
              )}
            </div>

            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 bg-gray-300 rounded"
                onClick={() => {
                  setSelectedFile(null);
                  setUploadModalOpen(false);
                }}
              >
                Cancel
              </button>

              <button
                className="px-4 py-2 bg-brand-primaryColor text-white rounded"
                onClick={saveUploadedFile}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DigitalSteth;
